(() => {
  // Find a stable ancestor — adjust selector to something that wraps
  // variant-selects but itself never gets re-rendered, e.g. the product form container
  const stableRoot = document.querySelector('.product__info-container, .product__form, [data-product-form]')?.closest('*')
    || document.body;

  const runUpdate = (container) => {
    const variantData = container.querySelector('[data-product-variants]');
    if (!variantData) return;
    const variants = JSON.parse(variantData.textContent)
      .filter(v => !v.hide_this_variant); // hide_this_variant metafield support

    const selections = [];
    container.querySelectorAll('.radio__input, .swatch__input').forEach((input) => {
      if (!input.checked) return;
      const index = parseInt(input.dataset.index.replace('option', ''), 10) - 1;
      selections[index] = input.value;
    });

    const option2Wrapper = container.querySelector('[data-option-position="2"]');
    if (option2Wrapper) {
      option2Wrapper.querySelectorAll('.radio__input, .swatch__input').forEach((input) => {
        const exists = variants.some((v) => v.options[0] === selections[0] && v.options[1] === input.value);
        const parent = input.closest('.radio__button') || input.closest('.swatch__button');
        if (!parent) return;
        const has = parent.classList.contains('unavailable');
        if (!exists && !has) parent.classList.add('unavailable');
        if (exists && has) parent.classList.remove('unavailable');
      });

      // if checked option2 is now unavailable, uncheck it and check first available
      const checkedOpt2 = option2Wrapper.querySelector('.radio__input:checked, .swatch__input:checked');
      const checkedOpt2Parent = checkedOpt2?.closest('.radio__button') || checkedOpt2?.closest('.swatch__button');
      if (checkedOpt2 && checkedOpt2Parent?.classList.contains('unavailable')) {
        checkedOpt2.checked = false;
        const firstAvailable = [...option2Wrapper.querySelectorAll('.radio__input, .swatch__input')]
          .find((input) => {
            const parent = input.closest('.radio__button') || input.closest('.swatch__button');
            return !parent?.classList.contains('unavailable');
          });
        if (firstAvailable) {
          firstAvailable.checked = true;
          selections[1] = firstAvailable.value;
          firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    const option3Wrapper = container.querySelector('[data-option-position="3"]');
    if (option3Wrapper) {
      option3Wrapper.querySelectorAll('.radio__input, .swatch__input').forEach((input) => {
        const exists = variants.some((v) =>
          v.options[0] === selections[0] && v.options[1] === selections[1] && v.options[2] === input.value
        );
        const parent = input.closest('.radio__button') || input.closest('.swatch__button');
        if (!parent) return;
        const has = parent.classList.contains('unavailable');
        if (!exists && !has) parent.classList.add('unavailable');
        if (exists && has) parent.classList.remove('unavailable');
      });

      // if checked option3 is now unavailable, uncheck it and check first available
      const checkedOpt3 = option3Wrapper.querySelector('.radio__input:checked, .swatch__input:checked');
      const checkedOpt3Parent = checkedOpt3?.closest('.radio__button') || checkedOpt3?.closest('.swatch__button');
      if (checkedOpt3 && checkedOpt3Parent?.classList.contains('unavailable')) {
        checkedOpt3.checked = false;
        const firstAvailable = [...option3Wrapper.querySelectorAll('.radio__input, .swatch__input')]
          .find((input) => {
            const parent = input.closest('.radio__button') || input.closest('.swatch__button');
            return !parent?.classList.contains('unavailable');
          });
        if (firstAvailable) {
          firstAvailable.checked = true;
          firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  };

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      document.querySelectorAll('variant-selects[data-product-options]').forEach(runUpdate);
      scheduled = false;
    });
  });

  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['checked']
  });

  document.querySelectorAll('variant-selects[data-product-options]').forEach(runUpdate);
})();